import React from 'react';
import { Modal, Box, Typography, Grid, IconButton, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import BusinessIcon from '@mui/icons-material/Business';
import MapIcon from '@mui/icons-material/Map';
import InfoIcon from '@mui/icons-material/Info';
import PublicIcon from '@mui/icons-material/Public';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WifiIcon from '@mui/icons-material/Wifi';
import RouterIcon from '@mui/icons-material/Router';

const fieldMap = [
  { key: 'fiber_pop', label: 'Fiber POP', icon: <WifiIcon color="action" /> },
  { key: 'latest_status', label: 'Status', icon: <CheckCircleIcon color="action" /> },
  { key: 'ran_region', label: 'RAN Region', icon: <MapIcon color="action" /> },
  { key: 'foo_region', label: 'FOO Region', icon: <MapIcon color="action" /> },
  { key: 'city_name', label: 'City', icon: <LocationOnIcon color="action" /> },
  { key: 'type', label: 'Type', icon: <RouterIcon color="action" /> },
  { key: 'telecom_region', label: 'Telecom Region', icon: <MapIcon color="action" /> },
  { key: 'ran_site_flag', label: 'RAN Site', icon: <BusinessIcon color="action" /> },
  { key: 'ola_location_flag', label: 'OLA Location', icon: <LocationOnIcon color="action" /> },
  { key: 'site_name', label: 'Site Name', icon: <BusinessIcon color="action" /> },
  { key: 'technology', label: 'Technology', icon: <RouterIcon color="action" /> },
  { key: 'vendor', label: 'Vendor', icon: <BusinessIcon color="action" /> },
  { key: 'route', label: 'Route', icon: <MapIcon color="action" /> },
  { key: 'latt', label: 'Latitude', icon: <PublicIcon color="action" /> },
  { key: 'long', label: 'Longitude', icon: <PublicIcon color="action" /> },
];

export default function FiberPopDetailsModal({ open, onClose, popData }) {
  if (!popData) {
    return null;
  }

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          p: 4,
          background: '#fff',
          borderRadius: 2,
          maxWidth: 1000,
          width: '95vw',
          mx: 'auto',
          my: 8,
          boxShadow: 24,
          position: 'relative',
          maxHeight: { xs: '90vh', sm: '80vh' },
          overflowY: 'auto',
        }}
      >
        <IconButton onClick={onClose} sx={{ position: 'absolute', top: 8, right: 8 }}>
          <CloseIcon />
        </IconButton>
        <Typography variant="h5" gutterBottom align="center">
          Fiber POP Details
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={2}>
          {fieldMap.map(
            ({ key, label, icon }) =>
              popData[key] !== undefined && (
                <Grid item xs={12} sm={6} md={4} key={key}>
                  <Box
                    display="flex"
                    alignItems="center"
                    bgcolor="#fafafa"
                    borderRadius={1}
                    p={1.5}
                    mb={1}
                    border="1px solid #e0e0e0"
                  >
                    {icon}
                    <Typography variant="subtitle2" sx={{ ml: 1, minWidth: 120, flexShrink: 0 }}>
                      {label}:
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        ml: 1,
                        fontWeight: 500,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        flex: 1,
                        minWidth: 0,
                      }}
                      title={
                        popData[key] === null || popData[key] === undefined || popData[key] === ''
                          ? '-'
                          : String(popData[key])
                      }
                    >
                      {popData[key] === null || popData[key] === undefined || popData[key] === ''
                        ? '-'
                        : String(popData[key])}
                    </Typography>
                  </Box>
                </Grid>
              )
          )}
        </Grid>
      </Box>
    </Modal>
  );
}
